module.exports = __webpack_public_path__ + "img/ask-the-faculty-banner.a3641579.jpg";